<template>
  <div class="same-div">
    <van-dialog v-model="showAppDownInfo" show-cancel-button confirm-button-text="复制" :close-on-click-overlay="true" @confirm="sureCopy"
                class-name="copyDialog" :message="downLoadAppInfoTips" style="color: black"></van-dialog>

    <div class="dialog_title_dark hx-flex-c-c hx-flex-j-b">
      <div class="title_new">
        制作属于你的AI智能体
      </div>
      <van-icon name="cross" @click="wantShow = false" />
    </div>
    <div class="dialog-content-custom">
      <div class="step_title_box" style="margin: 0 0 27px 0">
        <div class="step_title">
          <div class="step_title_left">
            01
          </div>
          <div class="step_title_right">
            <div> 长按图片识别购买 </div>
          </div>
        </div>
      </div>

      <div class="img_poster_box" v-show="userPoster !== ''" >
        <van-image class="img_box" lazy-load :src="userPoster">
          <template slot="error">加载失败</template>
        </van-image>
      </div>
      <div class="img_poster_box" v-show="userPoster === ''" >
        <van-image class="img_box" lazy-load :src="imgEmpty">
          <template slot="error">加载失败</template>
        </van-image>
      </div>

      <div class="step_title_box">
        <div class="step_title">
          <div class="step_title_left">
            02
          </div>
          <div class="step_title_right">
            请点击下载喵呜应用
          </div>
        </div>
      </div>
      <div class="step_content" style="margin-bottom: 36px">
        <div class="download_div">
          <van-button type="primary" size="middle" class="download_btn" @click="downloadApp"> 点击下载 </van-button>
        </div>
      </div>



      <div class="step_title_box" style="margin-top: 36px">
        <div class="step_title">
          <div class="step_title_left">
            03
          </div>
          <div class="step_title_right">
            注册喵呜账号
          </div>
        </div>
      </div>
      <div class="step_content" style="margin-bottom: 36px">
        使用激活码注册喵呜账号，开始制作您的专属AI智能体。
      </div>
      <div class="step_empty" style="width: 100%;height: 30px;float:left;">

      </div>

    </div>
  </div>
</template>

<script>
import { url_to_query } from '@/plugins/getUrlParam'
import Clipboard from 'clipboard'

export default {
  name: 'same',
  components: {},
  props: {

  },
  data () {
    return {
      // 下载应用复制粘贴
      clipboard: null,
      showAppDownInfo: false,
      downLoadAppInfoTips: '您可以复制下载地址',
      copyText: 'https://www.pgyer.com/meu_ai',
      userPoster: '', // "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/image_matting/1715591484.0407941.png",
      imgEmpty: 'https://awu-file.oss-cn-guangzhou.aliyuncs.com/applet/img_empty.png'
    }
  },
  mounted () {
    console.log('same page mounted')
    const params = url_to_query() || {}
    if (params?.poster){
      this.userPoster = 'https://' + decodeURIComponent(params?.poster)
    } else {
      this.userPoster = ''
    }
    console.log('this.userPoster:', this.userPoster)
    wx.miniProgram.previewImage({
      urls: [this.userPoster],
    });
  },
  computed: {},
  methods: {
    downloadApp() {
      let userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('miniprogram') !== -1) {
        console.log('在微信小程序中打开的webview');
        let tips, downLink
        if (!/iphone|ipad|ipod/.test(userAgent)){
          tips = "您可以复制 https://www.pgyer.com/meu_ai 到浏览器中打开下载"
          downLink = 'https://www.pgyer.com/meu_ai'
        } else {
          tips = "您可以复制'喵呜AI'到苹果应用商店进行下载"
          downLink = '喵呜AI'
        }
        // 无标题
        this.downLoadAppInfoTips = tips
        this.copyText = downLink
        this.showAppDownInfo = true
      } else {
        console.log('在浏览器中打开');
        if (/iphone|ipad|ipod/.test(userAgent)) {
          console.log('当前用户为 iOS 环境')
          if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
            this.qrShow = true
          } else {
            window.location.href = 'https://apps.apple.com/cn/app/喵呜ai/id6462773304';
          }
        } else {
          console.log('当前用户不是 iOS 环境')
          // https://www.meupop.com/app-release.apk
          window.location.href = 'https://www.pgyer.com/meu_ai';//https://app.aigcpop.com/meu
        }

      }
    },
    sureCopy() {
      // 复制到剪贴板
      this.clipboard = new Clipboard('.van-dialog__confirm', {
        text: () => this.copyText
      });

      this.clipboard .on('success', () => {
        console.log('复制成功')
        this.clipboard .destroy();
      });

      this.clipboard .on('error', () => {
        console.log('复制失败')
        this.clipboard .destroy();
      });
      // this.clipboard.onClick();
    },
  }
}
</script>

<style lang="less" scoped>
.same-div{
  width: 100vw;
  height: 100vh;
  margin: 0;
  background: white;
  padding: 50px 20px 0 20px;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
}

.dialog_main_dark {
  padding: 16px;
  color: white;
  // transform: translateZ(2px);
}
.dialog_title_dark {
  width: 100%;
  height: 32px;
  line-height: 1;
  padding-bottom: 16px;
  text-align: center;
}
.title_new{
  width: 100%;
  text-align: center;
  font-size: 22px;
}
.dialog-content-custom{
  width: 100%;
  height: calc(100vh - 64px);
  overflow: auto;
  .line_get_fun_1{
    float: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin: 16px 0 10px 0;
    display: flex;
    justify-content: center;
    .get_fun_1{
      width: 46px;
      height: 20px;
      padding: 2px 12px;
      background: #1edf41;
      color: black;
      font-size: 12px;
      border-radius: 5px;
    }
  }

  .step_content{
    float: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: black;
    line-height: 20px;
    margin: 16px 0 12px 0;
    display: flex;
    justify-content: center;


    .download_div{
      float: left;
      width: 100%;
      height: 40px;
      margin-bottom: 12px;
      display: flex;
      justify-content: center;
      .download_btn{
        width: 134px !important;
        height: 38px !important;;
        background: #1edf41;
        border-radius: 5px;
        font-size: 18px;
        font-weight: 500;
        color: black;
      }
    }
    .download_tip{
      float: left;
      width: 100%;
      height: 20px;
    }
  }

  .img_poster_box{
    float: left;
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
  }
  .img_box{
    width: 70%;
  }
}

.step_title_box{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 36px;
}
.step_title{
  position: relative;
  float: left;
  width: 246px;
  height: 35px;
  line-height: 28px;

  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0 auto;
  background: rgb(69, 69, 69);
  padding: 0 0 0 38px;
  box-sizing: border-box;
  border-radius: 6.66px;
}
.step_title_left{
  float: left;
  width: 50px;
  height: 35px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  margin-right: 10px;
  background: rgb(30, 223, 65);
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  clip-path: polygon(0% 0.33%, 65% 0%, 100% 100%, 0% 100%);
  border-top-left-radius: 6.66px;
  border-bottom-left-radius: 6.66px;
  text-align: center;
  padding: 0 10px 0 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.step_title_right{
  flex: 1;
  float: right;
  max-width: 190px;
  height: 35px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  text-align: left;
  border-top-right-radius: 6.66px;
  border-bottom-right-radius: 6.66px;
  padding: 0 0 0 16.66px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
